export const GET_WORKI_INDEX_DISP = 'GET_WORKI_INDEX_DISP'
export const GET_WORKI_DETAIL_DISP = 'GET_WORKI_DETAIL_DISP'
export const SET_WORKI_TOGGLE_PAGE = 'SET_WORKI_TOGGLE_PAGE'

export const SET_WORKI = 'SET_WORKI'
export const GET_WORKI = 'GET_WORKI'
export const RECEIVED_WORKI = 'RECEIVED_WORKI'

export const SET_WORKI_DETAIL = 'SET_WORKI_DETAIL'
export const GET_WORKI_DETAIL = 'GET_WORKI_DETAIL'
export const RECEIVED_WORKI_DETAIL = 'RECEIVED_WORKI_DETAIL'



// WEBPACK FOOTER //
// ./src/workI/store/mutation-types.js